import TableInput from './TableInput'

export default TableInput
